"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Control = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var utils_1 = require("utils");
var Navigation_1 = require("../Navigation");
var useControlGroup_1 = require("./useControlGroup");
var useIsSelectedControl_1 = require("./useIsSelectedControl");
var CONTAINER_STYLES = "relative first:border first:border-r-0 last:border border-t border-l border-b border-gray-400 first:rounded-tl-md first:rounded-bl-md last:rounded-tr-md last:rounded-br-md flex items-center justify-center w-12 h-8 p-5 transition-colors duration-200 ease-linear";
var CONTAINER_SELECTED_STYLES = "bg-gray-400 hover:bg-gray-400 shadow-inner";
var CONTAINER_ENABLED_STYLES = "bg-white hover:bg-gray-200";
var INPUT_STYLES = "absolute bottom-0 h-full left-0 opacity-0 right-0 top-0 w-full";
var INPUT_DISABLED_STYLES = "cursor-not-allowed";
var DISABLED_STYLES = INPUT_DISABLED_STYLES + " opacity-50";
var ENABLED_STYLES = "cursor-pointer";
var Control = function (_a) {
    var id = _a.id, value = _a.value, className = _a.className, disabled = _a.disabled, _b = _a.type, type = _b === void 0 ? "radio" : _b, children = _a.children, tooltip = _a.tooltip;
    var _c = (0, react_1.useState)(false), hover = _c[0], setHover = _c[1];
    var _d = (0, useControlGroup_1.useControlGroup)(), register = _d.register, name = _d.name;
    var isSelected = (0, useIsSelectedControl_1.useIsSelectedControl)(value);
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: (0, utils_1.concatStyles)(CONTAINER_STYLES, className, disabled && DISABLED_STYLES, !disabled && ENABLED_STYLES && CONTAINER_ENABLED_STYLES, isSelected && CONTAINER_SELECTED_STYLES), onMouseOver: function () { return setHover(true); }, onMouseOut: function () { return setHover(false); } }, { children: [tooltip ? (0, jsx_runtime_1.jsx)(Navigation_1.ToolTip, { active: hover, label: tooltip }, void 0) : null, (0, jsx_runtime_1.jsx)("input", __assign({}, register === null || register === void 0 ? void 0 : register(name), { id: id !== null && id !== void 0 ? id : name, value: value, type: type, disabled: disabled, className: (0, utils_1.concatStyles)(INPUT_STYLES, disabled && INPUT_DISABLED_STYLES, !disabled && ENABLED_STYLES) }), void 0), children] }), void 0));
};
exports.Control = Control;
